/* ============ 左侧目录展开 / 收起 ============ */
$('.toc_group .toc_part').on('click', function () {
    $(this).closest('.toc_group').toggleClass('active');
});
